import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { DesignSystemModule } from '../design-system/design-system.module';
import { HttpClient } from '@angular/common/http';
// import { createTranslateSharedLoader } from '../utils/createTranslateLoader';
@NgModule({
  declarations: [LayoutComponent, SidebarComponent, HeaderComponent],
  imports: [
    CommonModule,
    RouterModule,
    // TranslateModule.forRoot({
    //   defaultLanguage: 'ar',
    //   loader: {
    //     provide: TranslateLoader,
    //     useFactory: createTranslateSharedLoader,
    //     deps: [HttpClient],
    //   },
    //   isolate: true,
    // }),
    SharedModule,
    DesignSystemModule,
    TranslateModule
  ]
})
export class LayoutModule {}
